import { EndpointContract } from '../../architecture/ControllerContract';
import { z } from 'zod';
import { objectId } from '../ObjectId';
import { assistantChatMessage, chatMessage } from './ChatMessage';

const body = z.object({
    chatId: objectId,
    sessionId: objectId,
    message: chatMessage.refine(
        message => {
            if (message.role === 'user') {
                return message.content.contentType === 'plain-text';
            }
            if (message.role === 'assistant') {
                return message.content.contentType !== 'markdown';
            }
            return false;
        },
        {
            message: 'Invalid message content type for the specified role'
        }
    )
});

export const sendMessage = {
    verb: 'post',
    path: 'send-message',
    schema: {
        body: body,
        response: {
            200: z
                .object({
                    assistantChatMessages: z.array(assistantChatMessage)
                })
                .strict()
        }
    }
} as const satisfies EndpointContract;
export type SendMessage = z.infer<typeof body>;
